import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.#clearCookie()) {
      this.element.classList.remove("hidden")
    }

    this._onBeforeCache = () => this.element.classList.add("hidden")
    document.addEventListener("turbo:before-cache", this._onBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this._onBeforeCache)
  }

  #clearCookie() {
    const present = document.cookie.includes("_flash=")
    document.cookie = "_flash=; path=/; max-age=0; SameSite=Strict"
    return present
  }

  remove() {
    this.element.remove();
  }
}
